import {scaleOrdinal} from 'd3-scale';

function _scale() {
  let yAt = this.axisY();
  if (yAt) { //right 방향에도 공간을 만들어줘야함
    this.axis({target: 'y', orient: 'right'});
  }

  const scale = this.scale();
  scale.color = scaleOrdinal().domain(this.measures().map(d => d.field)).range(this.color());
}



export default _scale;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/combo/_scale.js